<template>
  <div class="">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formSearch" class="demo-form-inline d-s-s f-w">
        <el-form-item label="类型筛选">
          <el-button-group>
            <el-button @click="changeTypeFunc('')">不限</el-button>
            <el-button :type="formSearch.form_id == item.form_id ? 'primary' : ''" plain v-for="(item, index) in category" :key="index" @click="changeTypeFunc(item.form_id)">{{item.name}}</el-button>
          </el-button-group>
        </el-form-item>
        <br>
        <el-form-item label="类型" v-if="formSearch.form_id==2">
          <el-select v-model="formSearch.type" placeholder="请选择" clearable>
            <el-option label="不限" value=""></el-option>
            <el-option v-for="(item,index) in type" :key="index" :label="item.name" :value="item.key_name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="填写昵称QQ手机">
          <el-input v-model="formSearch.keyword" placeholder="请输入" clearable></el-input>
        </el-form-item>
        <el-form-item label="授权昵称或绑定手机">
          <el-input v-model="formSearch.user" placeholder="请输入" clearable></el-input>
        </el-form-item>
        <el-form-item label="用户id">
          <el-input v-model="formSearch.user_id" placeholder="请输入" clearable></el-input>
        </el-form-item>
        <el-form-item label="总分" v-if="formSearch.form_id==3">
          <el-input v-model="formSearch.score[0]" placeholder="大于该分数" style="width:100px"></el-input>
          <span class="p-0-10">至</span>
          <el-input v-model="formSearch.score[1]" placeholder="小于等于该分数" style="width:120px"></el-input>
        </el-form-item>

        <el-form-item label="添加日期时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker v-model="formSearch.create_time" clearable type="datetimerange"  value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期时间"
              end-placeholder="结束日期时间">
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
          <el-button size="small" type="success" @click="onExport">导出</el-button>
          <span>注：拟排名-成绩截图请到OSS浏览器工具，进入后找到 <span class="f20">rank</span> 文件夹右键下载</span>
        </el-form-item>
      </el-form>
    </div>

    <!--内容-->
    <div class="content mt10">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading" @sort-change="sortChange">
          <el-table-column prop="custom_id" label="ID" width="80" sortable="custom"></el-table-column>
          <el-table-column prop="form.name" label="类型" width="80"></el-table-column>
          <el-table-column prop="type" label="来源" width="80" >
            <template slot-scope="scope">
              {{ scope.row.type>0 ? type[scope.row.type].name : '' }}
            </template>
          </el-table-column>
          <el-table-column prop="user.nickName" label="用户" width="200">
            <template slot-scope="scope">
              <div v-if="scope.row.user">
                <p>用户ID：{{scope.row.user.user_id}} <el-tag type="info" class="style1-tag">小程序</el-tag></p>
                <p>昵称：{{scope.row.user.nickName}}</p>
                <p v-if="scope.row.user.mobile">手机：{{scope.row.user.mobile}}</p>
              </div>
              <el-tag type="info" class="style2-tag" v-else>QQ</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="content" label="填写" >
            <template slot-scope="scope" >
              <div>
                <span class="f14 red" v-if="scope.row.pm>0">排名：{{ scope.row.pm }}</span>
                <span class="ml20 blue" v-if="scope.row.find_count>0">查询数：{{ scope.row.find_count }}</span>
              </div>
              
              <div v-for="(v, i) in scope.row.content" :key="i">
                <p v-if="v.key_name=='6uyX20211020161201' || v.key_name=='ptFX20211020162100' || v.key_name=='hyMU20211020162055' || v.key_name=='hAGZ20211105195140' || v.key_name=='6muA20211105195202' || v.key_name=='hyHP20211105195217' || v.key_name=='3gtD20211105195824' || v.key_name=='7nGQ20211105195245' || v.key_name=='4bce20211105200015' || v.key_name=='46nx20211105200031'">
                  {{v.question+'：'+v.answer}}
                  <span v-if="v.text">{{ v.text }}</span>
                </p>
              </div>
              <div v-if="scope.row.score">总分：{{scope.row.score}}</div>
            </template>
          </el-table-column>
          <el-table-column label="成绩截图">
            <template slot-scope="scope">
              <div v-for="(v, i) in scope.row.content" :key="i">
                <el-image class="imgw100" v-if="v.key_name=='gsJR20211105195914' && v.image" :src="v.image" fit="cover" :preview-src-list="[v.image]" alt="" />
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="添加时间" sortable="custom"></el-table-column>
          <el-table-column prop="name" label="操作" width="160" align="center">
            <template slot-scope="scope">
              <el-button @click="openPopup('detail', scope.row)" type="text" size="small">查看详情</el-button>
              <el-button @click="deleteFun(scope.row)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-sizes="[20, 50, 100, 200, 300, 500]"
          :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>

    <!--批量-->
    <Detail v-if="show_popup['detail']" :is_open="show_popup['detail']" :selectModel="selectModel" @closeDialog="closeDialogFunc($event, 'detail')"></Detail>

  </div>
</template>
<script>
  import CustomApi from '@/api/study/custom.js';
  import Detail from './detail.vue';
  import qs from 'qs';
  export default {
    components: {
      Detail
    },
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*横向表单数据模型*/
        formSearch: {
          user: '',
          keyword: '',
          user_id: '',
          form_id: '',
          type: '',
          create_time: '',
          score: [],
        },
        category: [],
        type: [],
        /*弹窗*/
        show_popup: {
          detail: false,
        },
        /*选中的对象*/
        selectModel:{},
        input_type:[],
        multipleSelection: [],
        ids: [],
      };
    },
    created() {
      const params = this.$route.query;
      Object.assign(this.formSearch, params);

      // 默认
      let form_id = this.$db.getRouteField(this, 'form_id');
      if (form_id) this.formSearch.form_id = form_id;

      /*获取列表*/
      this.getTableList();
    },
    methods: {
      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = self.formSearch;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        Params.sort_name = self.sortName;
        Params.sort_value = self.sortValue;
        CustomApi.getList(Params, true).then(res => {
          let data = res.data;
          self.loading = false;
          self.tableData = data.list.data;
          self.category = data.category;
          self.type = data.type;
          self.totalDataNumber = data.list.total;
        }).catch(error => {
          self.loading = false;
        });
      },

      /*搜索查询*/
      onSubmit() {
        let self = this;
        self.loading = true;
        self.getTableList();
      },

      /*排序查询*/
      sortChange(e){
        if (e.order && e.order != null){
          this.sortName = e.prop;
          this.sortValue = e.order=='ascending' ? 'asc' : 'desc';
        }else{
          this.sortName = this.sortValue = '';
        }
        this.tableData = [];
        this.getTableList();
      },

      /*打开弹窗*/
      openPopup(name, item){
        this.show_popup[name] = true;
        if (item) this.selectModel = item;
      },

      /*关闭弹窗*/
      closeDialogFunc(e, f) {
        this.show_popup[f] = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      },

      /*选择类型*/
      changeTypeFunc(e){
        if (e !=2 ){
          this.formSearch.type = '';
        }
        this.formSearch.form_id = e;
        this.$db.setRoute(this, {'form_id': e});
        this.curPage = 1;
        this.tableData = [];
        this.getTableList();
      },
      
      /*导出*/
      onExport: function() {
        if (!this.formSearch.form_id){
          this.$message({
              message: '请选择类型导出',
              type: 'warning'
          });
          return;
        }
        let baseUrl = window.location.protocol + '//' + window.location.host;
        window.location.href = baseUrl + '/index.php/shop/study.custom/export?' + qs.stringify(this.formSearch);
      },

      /*删除*/
      deleteFun(row) {
        let self = this;
        self.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          self.loading = true;
          CustomApi.del({custom_id: row.custom_id}, true)
              .then(data =>{
                self.loading = false;
                self.$message({
                    message: data.msg,
                    type: 'success'
                });
                self.getTableList();
              })
              .catch(error =>{
                self.loading = false;
              });
        }).catch(() => {});
      },

    }
  };
</script>
<style></style>


// WEBPACK FOOTER //
// src/views/study/custom/list/index.vue